/* Тег скрипта выводится в каждой карточке товара (Liquid-снippet рендерится
   на карточку, а increment внутри render имеет изолированный scope), поэтому
   файл защищён флагом от повторного выполнения. Браузер скачивает его один раз. */
if (!window.__variantButtonCollectionReady) {
  window.__variantButtonCollectionReady = true;

(function() {
  function updateMoreOptionsText() {
    const isMobile = window.matchMedia('(max-width: 767px)').matches;

    document.querySelectorAll('.grid-product-option-more').forEach(el => {
      const desktopMore = parseInt(el.dataset.desktopMore) || 0;
      const mobileMore = parseInt(el.dataset.mobileMore) || 0;
      const value = isMobile ? mobileMore : desktopMore;

      if (value > 0) {
        el.textContent = '+' + value;
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    });
  }

  if (!window.__variantButtonCollectionBound) {
    document.addEventListener('click', function(e) {
      if (!e.target.matches('.grid-product-option-more')) return;

      e.preventDefault();
      const btn = e.target;

      if (!window.matchMedia('(max-width: 767px)').matches) {
        const gridItem = btn.closest('.grid__item-collection');
        const productUrl = gridItem?.querySelector('a[href*="/products/"]')?.href;
        if (productUrl) {
          window.location.href = productUrl;
        }
        return;
      }

      const variantWrapper = btn.closest('.variant-wrapper-collection');
      const gridItem = btn.closest('.grid__item-collection');
      const form = gridItem?.querySelector('form[data-product-form]');

      if (!variantWrapper || !gridItem) return;

      const allVariants = variantWrapper.querySelectorAll('.variant-input-collection');
      const optionName = btn.dataset.optionName || '';

      openVariantPopup(allVariants, optionName, form, gridItem);
    });

    document.addEventListener('click', function(e) {
      const variantInput = e.target.closest('.grid__item-collection .variant-input-collection');
      if (!variantInput) return;

      const variantId = variantInput.dataset.variantId;
      const gridItem = variantInput.closest('.grid__item-collection');

      if (variantId && gridItem) {
        gridItem.dataset.selectedVariantId = variantId;

        const productLinks = gridItem.querySelectorAll('a[href*="/products/"]');
        productLinks.forEach(link => {
          const baseUrl = link.href.split('?')[0];
          link.href = baseUrl + '?variant=' + variantId;
        });
      }
    });

    window.__variantButtonCollectionBound = true;
  }

  function openVariantPopup(variants, optionName, form, gridItem) {
    const existingPopup = document.querySelector('.variant-options-popup');
    if (existingPopup) {
      existingPopup.remove();
    }

    const popup = document.createElement('div');
    popup.className = 'variant-options-popup';
    popup.innerHTML = `
      <div class="variant-options-popup__overlay"></div>
      <div class="variant-options-popup__content">
        <div class="variant-options-popup__header">
          <h3>${optionName}</h3>
          <button type="button" class="variant-options-popup__close">&times;</button>
        </div>
        <div class="variant-options-popup__body">
          ${Array.from(variants).map(v => {
            const label = v.querySelector('label')?.textContent?.trim() || '';
            const isActive = v.classList.contains('is-active');
            const variantId = v.dataset.variantId;
            const isAvailable = v.dataset.available === 'true';
            const price = v.dataset.price;
            const compareAtPrice = v.dataset.compareAtPrice;

            // Получаем background-image для shape опций
            const labelElement = v.querySelector('label');
            const isShape = labelElement?.classList.contains('shape-swatch-collection');
            let shapeImage = '';
            if (isShape && labelElement) {
              const bgImage = labelElement.style.backgroundImage;
              if (bgImage) {
                shapeImage = bgImage.replace(/^url\(['"]?/, '').replace(/['"]?\)$/, '');
              }
            }

            let priceHtml = '';
            if (price) {
              try {
                // Use the formatMoney function from product-grid-item-collection
                const formatMoney = window.formatMoneyCollection || function(cents) {
                  if (typeof cents === 'string') cents = parseInt(cents);

                  // Try theme.Currency first
                  if (typeof theme !== 'undefined' && theme.Currency && theme.Currency.formatMoney) {
                    var moneyFormat = theme.settings && theme.settings.moneyFormat ? theme.settings.moneyFormat : null;
                    return theme.Currency.formatMoney(cents, moneyFormat);
                  }

                  // Fallback to Shopify.formatMoney if available
                  if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
                    var shopifyFormat = window.Currency && window.Currency.moneyFormats
                      ? window.Currency.moneyFormats[window.Currency.currentCurrency]
                      : null;
                    if (shopifyFormat) {
                      return Shopify.formatMoney(cents, shopifyFormat);
                    }
                  }

                  // Final fallback
                  const value = (cents / 100).toFixed(2);
                  return '€' + value.replace('.', ',');
                };

                const formattedPrice = formatMoney(price);

                if (compareAtPrice && parseInt(compareAtPrice) > parseInt(price)) {
                  const formattedCompare = formatMoney(compareAtPrice);
                  priceHtml = `<span class="variant-popup-price"><span class="variant-popup-price--compare">${formattedCompare}</span> <span class="variant-popup-price--sale">${formattedPrice}</span></span>`;
                } else {
                  priceHtml = `<span class="variant-popup-price">${formattedPrice}</span>`;
                }
              } catch (error) {
                console.error('Error formatting price in variant popup:', error);
                // Simple fallback display
                const rawPrice = (parseInt(price) / 100).toFixed(2);
                priceHtml = `<span class="variant-popup-price">${rawPrice}</span>`;
              }
            }

            // Формируем HTML с картинкой слева для shape
            let shapeImageHtml = '';
            if (isShape && shapeImage) {
              shapeImageHtml = `<div class="variant-popup-shape-image" style="background-image: url(${shapeImage})"></div>`;
            }

            return `
              <button type="button" class="variant-options-popup__item ${isShape ? 'variant-options-popup__item--shape' : ''} ${isActive ? 'is-active' : ''} ${!isAvailable ? 'is-unavailable' : ''}"
                data-variant-id="${variantId}"
                data-available="${isAvailable}">
                ${shapeImageHtml}
                <span class="variant-popup-label">${label}</span>
                ${priceHtml}
              </button>
            `;
          }).join('')}
        </div>
        <div class="variant-options-popup__footer">
          <button type="button" class="variant-options-popup__add-to-cart btn btn--full">
            Add to Cart
          </button>
        </div>
      </div>
    `;

    document.body.appendChild(popup);
    document.body.style.overflow = 'hidden';

    setTimeout(() => popup.classList.add('is-open'), 10);

    const closePopup = () => {
      popup.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(() => popup.remove(), 300);
    };

    popup.querySelector('.variant-options-popup__close').addEventListener('click', closePopup);
    popup.querySelector('.variant-options-popup__overlay').addEventListener('click', closePopup);

    popup.querySelectorAll('.variant-options-popup__item').forEach(item => {
      item.addEventListener('click', () => {
        if (item.classList.contains('is-unavailable')) {
          return;
        }

        popup.querySelectorAll('.variant-options-popup__item').forEach(i => i.classList.remove('is-active'));
        item.classList.add('is-active');

        const variantId = item.dataset.variantId;
        const targetVariant = Array.from(variants).find(v => v.dataset.variantId === variantId);
        if (targetVariant) {
          const radioInput = targetVariant.querySelector('input[type="radio"]');
          if (radioInput && !radioInput.disabled) {
            radioInput.checked = true;
            radioInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
    });

    popup.querySelector('.variant-options-popup__add-to-cart').addEventListener('click', () => {
      const activeItem = popup.querySelector('.variant-options-popup__item.is-active:not(.is-unavailable)');
      let variantId = activeItem?.dataset.variantId;

      if (!variantId) {
        const firstAvailable = popup.querySelector('.variant-options-popup__item:not(.is-unavailable)');
        if (firstAvailable) {
          firstAvailable.click();
          setTimeout(() => {
            popup.querySelector('.variant-options-popup__add-to-cart').click();
          }, 100);
        }
        return;
      }

      if (activeItem?.dataset.available === 'false') {
        alert('This option is not available');
        return;
      }

      const targetVariant = Array.from(variants).find(v => v.dataset.variantId === variantId);
      if (targetVariant) {
        const radioInput = targetVariant.querySelector('input[type="radio"]');
        if (radioInput && !radioInput.checked) {
          radioInput.checked = true;
          radioInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      if (form) {
        const variantIdInput = form.querySelector('[data-variant-id-input], input[name="id"]');
        if (variantIdInput) {
          variantIdInput.value = variantId;
        }

        const variantSelect = form.querySelector('[data-product-select]');
        if (variantSelect) {
          variantSelect.value = variantId;
        }

        setTimeout(() => {
          const submitBtn = form.querySelector('[data-add-to-cart]');
          if (submitBtn && !submitBtn.disabled) {
            submitBtn.click();
          } else {
            const formData = new FormData();
            formData.append('id', variantId);

            fetch('/cart/add.js', {
              method: 'POST',
              body: formData,
              headers: {'X-Requested-With': 'XMLHttpRequest'}
            })
            .then(response => response.json())
            .then(data => {
              // Используем стандартное событие темы
              document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                detail: { product: data },
                bubbles: true
              }));
            })
            .catch(error => console.error('Error adding to cart:', error));
          }
          closePopup();
        }, 100);
      } else {
        closePopup();
      }
    });
  }

  window.openVariantPopup = openVariantPopup;

  document.addEventListener('DOMContentLoaded', updateMoreOptionsText);
  document.addEventListener('collection:reloaded', updateMoreOptionsText);
  document.addEventListener('shopify:section:load', updateMoreOptionsText);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateMoreOptionsText);
  } else {
    updateMoreOptionsText();
  }
})();

}
